import { FormBase } from 'core/components';

export default class EditOrderForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}
	setup() {
		return {
			fields: [
				{
					name: 'shippingAddress1',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS1',
					rules: 'required',
				},
				{
					name: 'shippingAddress2',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGADDRESS2',
				},
				{
					name: 'shippingZipCode',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGZIPCODE',
					rules: 'required',
				},
				{
					name: 'shippingCoreCountryId',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGCOUNTRY',
					rules: 'required',
				},
				{
					name: 'shippingCoreCountryStateId',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGSTATE',
					rules: 'required',
				},
				{
					name: 'buyerName',
					label: 'MARKETPLACEORDEREDITFORM.BUYERNAME',
					rules: 'required',
				},
				{
					name: 'buyerPhone',
					label: 'MARKETPLACEORDEREDITFORM.PHONE',
					rules: 'required',
				},
				{
					name: 'shippingCity',
					label: 'MARKETPLACEORDEREDITFORM.SHIPPINGCITY',
					rules: 'required',
				},
				{
					name: 'shipByDate',
					label: 'MARKETPLACEORDEREDITFORM.SHIPBYDATE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/EditOrderForm.js